import Api from './index';
import {DATA_CATION_URL} from './urls';

export const getRecommendedContent = async (id: any) => {
  const response = await Api('ai').get(`${DATA_CATION_URL}/${id}`);
  const result = response;
  return result;
};
export const postRecommendedContent = async (data: any) => {
  const response = await Api('ai').post(`${DATA_CATION_URL}`, data);
  const result = response;
  return result;
};
